import { objToString } from './stringUtils';

/**
 * @deprecated use JsonUtils clone instead.
 */
export function objClone(obj: any) {
  try {
    const clone = structuredClone(obj);
    return clone;
  } catch (ex) {
    return JSON.parse(objToString(obj));
  }
}
